import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiBell } from 'react-icons/fi'
import { useLanguageStore } from '../../store/languageStore'
import { useFuelNotificationStore } from '../../store/fuelNotificationStore'
import { apiClient } from '../../api/client'
import { API_ENDPOINTS } from '../../api/endpoints'

export default function FuelStationLiveToasts() {
  const isRTL = useLanguageStore((s) => s.language) === 'ar'
  const live = useFuelNotificationStore((s) => s.live)
  const dismissLive = useFuelNotificationStore((s) => s.dismissLive)
  const markLocalRead = useFuelNotificationStore((s) => s.markLocalRead)
  const navigate = useNavigate()

  useEffect(() => {
    if (!live.length) return
    const timers = live.map((n) =>
      window.setTimeout(() => dismissLive(n.notificationId), 14000)
    )
    return () => timers.forEach((t) => window.clearTimeout(t))
  }, [live, dismissLive])

  if (!live.length) return null

  return (
    <div className={`fixed z-[80] top-20 flex flex-col gap-2 w-[min(26rem,calc(100vw-1.5rem))] ${isRTL ? 'left-4' : 'right-4'}`}>
      {live.map((n) => (
        <button
          key={n.notificationId}
          type="button"
          onClick={async () => {
            markLocalRead(n.notificationId)
            try {
              await apiClient.post(API_ENDPOINTS.fuelStation.notificationRead(n.notificationId))
            } catch {
              /* still navigate */
            }
            navigate(n.actionUrl || '/fuel-station/notifications')
          }}
          className={`text-right rounded-2xl shadow-2xl border px-4 py-3 bg-slate-900 text-white border-teal-400/40 ${
            n.priority === 'critical' ? 'ring-2 ring-rose-400' : n.needsAction ? 'ring-2 ring-amber-400' : ''
          }`}
        >
          <div className="flex items-start gap-3">
            <span className="mt-0.5 shrink-0 rounded-full bg-teal-500 p-2">
              <FiBell className="h-4 w-4" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold leading-snug">{n.title}</p>
              <p className="mt-1 whitespace-pre-line text-xs text-white/80 leading-relaxed">{n.message}</p>
            </div>
            <span
              className="text-white/50 text-lg leading-none px-1"
              onClick={(e) => {
                e.stopPropagation()
                dismissLive(n.notificationId)
              }}
            >
              ×
            </span>
          </div>
        </button>
      ))}
    </div>
  )
}
